import React from 'react';
import StatusLed from './widgets/status-led';
import formatLastSeenOnline from '../utils/format-last-seen-online';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function DeviceStatus(props: any) {
  return (
    <span>
      <StatusLed status={props.connectionStatus} redStatusName="disconnected" greenStatusName="connected" />
      <span>{props.title}</span>
      {/* {props.connectionStatus === 'disconnected' ? (
        <span>Last Seen Online: {formatLastSeenOnline(props.lastSeenOnline)}</span>
      ) : (
        ''
      )} */}
    </span>
  );
}
